import type { AdminProviderVM } from "@shared-kernel/application/ports/admin/admin-repository";
import type { Nullable } from "@shared-kernel/core/types/nullable";
import { createApiThunk } from "@shared-kernel/application/create-api-thunk";

export const retrieveProvider = createApiThunk<Nullable<AdminProviderVM>, string>(
  "providers/retrieveProvider",
  async (id: string, { extra: { adminRepository } }) => {
    return adminRepository!.getProvider(id);
  },
);
